import React, { useState } from 'react'
import { useAuth } from '../auth.jsx'
import { AccountSection, SecuritySection } from '@components/AccountSecuritySections.jsx'
import { getMode, getTheme, setMode, setTheme } from '@theme'

const THEMES = [
  { value: 'default', label: 'Default' },
  { value: 'warm', label: 'Warm' },
  { value: 'forest', label: 'Forest' },
  { value: 'ocean', label: 'Ocean' },
]

const MODES = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' },
]

function AppearanceSection() {
  const [theme, setThemeState] = useState(() => getTheme())
  const [mode, setModeState] = useState(() => getMode())
  return (
    <section style={styles.section}>
      <p style={styles.sectionLabel}>Appearance</p>
      <div style={styles.card}>
        <p style={styles.note}>Theme</p>
        <div style={styles.optionRow}>
          {THEMES.map((opt) => {
            const active = theme === opt.value
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => { setTheme(opt.value); setThemeState(opt.value) }}
                style={{ ...styles.pill, ...(active ? styles.pillActive : {}) }}
                aria-pressed={active}
              >
                {opt.label}
              </button>
            )
          })}
        </div>
        <p style={{ ...styles.note, marginTop: 16 }}>Mode</p>
        <div style={styles.optionRow}>
          {MODES.map((opt) => {
            const active = mode === opt.value
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => { setMode(opt.value); setModeState(opt.value) }}
                style={{ ...styles.pill, ...(active ? styles.pillActive : {}) }}
                aria-pressed={active}
              >
                {opt.label}
              </button>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export function UserSettingsPage() {
  const { user } = useAuth()
  if (!user) return null
  return (
    <div style={styles.inner}>
      <h2 style={styles.title}>Settings</h2>
      <AccountSection user={user} />
      <AppearanceSection />
      <SecuritySection user={user} />
    </div>
  )
}

const styles = {
  inner: {
    maxWidth: '640px',
    margin: '0 auto',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: 'var(--text-primary)',
    margin: '0 0 28px 0',
  },
  section: { marginBottom: 28 },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: 'var(--text-secondary)',
    margin: '0 0 8px 0',
  },
  card: {
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    padding: 16,
    background: 'var(--surface)',
  },
  note: {
    fontSize: 13,
    color: 'var(--text-secondary)',
    margin: '0 0 8px 0',
  },
  optionRow: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  pill: {
    padding: '6px 14px',
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 999,
    border: '1px solid var(--border)',
    background: 'transparent',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
  },
  pillActive: {
    background: 'var(--accent-brand-bg)',
    color: 'var(--accent-brand-text)',
  },
}
